import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import SummaryCard from './summaryCard';
import {
  HourglassEmpty,
  RecentActors,
  Timer,
  AccountBalanceWallet,
} from '@material-ui/icons';
import { useState } from 'react';
import { useEffect } from 'react';
import { getJobSummary } from 'controllers/dashboard/getJobSummary';

const useStyles = makeStyles(() => ({
  card: {
    padding: '0 25px 20px 0',
    borderRadius: 2,
  },
}));

const SummaryCards = ({ jobId }) => {
  const classes = useStyles();
  const [summary, setSummary] = useState({});

  useEffect(() => {
    const fetchSummary = async () => {
      const response = await getJobSummary(jobId);
      setSummary(response);
    };

    fetchSummary();
  }, [jobId]);

  return (
    <>
      <Grid container>
        <Grid item xs={6} classes={{ root: classes.card }}>
          <SummaryCard
            Icon={HourglassEmpty}
            title={summary.jobActiveFrom || ''}
            subtitle={'Job Active From'}
          />
        </Grid>
        <Grid item xs={6} classes={{ root: classes.card }}>
          <SummaryCard
            Icon={RecentActors}
            title={summary.applications || ''}
            subtitle={'Applicants'}
          />
        </Grid>
        <Grid item xs={6} classes={{ root: classes.card }}>
          <SummaryCard
            Icon={Timer}
            title={summary.screeningTimeSaved || ''}
            subtitle={'Screening Time Saved'}
          />
        </Grid>
        <Grid item xs={6} classes={{ root: classes.card }}>
          <SummaryCard
            Icon={AccountBalanceWallet}
            title={summary.moneySaved || ''}
            subtitle={'Money Saved'}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SummaryCards;
